import React from 'react';
import logo from '../images/build_animated.gif';

function Navbar() {
    return (
        <nav>
            <a href='#' className='logo'>
                <img src={logo} alt='KNS_logo'/>
            </a>
            <input className='menu-btn' type='checkbox' id='menu-btn'/>
            <label className='menu-icon' for='menu-btn'>
                <span className='nav-icon'></span>
            </label>
            <ul className='menu'>
                <li><a href='#' className='active'>Home</a></li>
                <li><a href='/About'>About</a></li>
                <li><a href='/Careers'>Careers</a></li>
                <li><a href='/Projects'>Projects</a></li>
                <li><a href='/Contact'>Contact</a></li>
            </ul>
            <a href='/Register' className='property'>Register</a>
            <a href='/Login' className='property'>Login</a>
            
        </nav>
    );
}

export default Navbar;
